export interface NewsArticle {
  id: number;
  slug: string;
  title: string;
  summary: string;
  category: string;
  categoryName: string;
  tags: string[];
  author: string;
  timeLabel: string;
  dateLabel: string;
  isTop?: boolean;
  views: number;
  image: string;
  content: string[];
}

export const newsArticles: NewsArticle[] = [
  {
    id: 1,
    slug: "xiayi-dianying-houji",
    title: "《晚风号列车》首映口碑爆棚，导演自曝筹备十年",
    summary:
      "一部没有流量担当的文艺片，却在首映礼上赢得满堂彩。导演在现场哽咽自曝，这个关于告别的故事，他整整打磨了十年。",
    category: "yule",
    categoryName: "娱乐",
    tags: ["电影", "首映", "口碑"],
    author: "本网娱乐组",
    timeLabel: "08:12",
    dateLabel: "2026-09-07",
    isTop: true,
    views: 286000,
    image:
      "https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20vintage%20train%20gliding%20through%20warm%20orange%20dusk%20landscape%20with%20soft%20clouds%2C%20cinematic%20minimalist%20art%20style%2C%20coral%20red%20and%20cream%20color%20palette%2C%20film%20poster%20aesthetic%2C%20warm%20ambient%20lighting&width=800&height=600&seq=film-train-01&orientation=landscape",
    content: [
      "昨晚，筹备多年的文艺电影《晚风号列车》在北京举行首映礼。片中没有任何流量演员，全凭扎实的剧本和克制的表演赢得观众阵阵掌声。散场后，不少影迷在社交平台写下长评，称其为\"今年最值得二刷的作品之一\"。",
      "导演在映后交流环节几度哽咽。他坦言，这个关于'与过去的自己和解'的故事，从剧本立项到最终杀青整整用了十年，期间推翻重写七稿，也曾因为找不到投资而差点放弃。\"能把它拍出来，本身就已经是幸运。\"",
      "业内人士评价，影片用一辆驶向终点的列车隐喻人生，画面克制却处处动人。点映与首映场几乎场场满座，预售成绩也超出片方预期，成为本月最受关注的文艺片之一。",
      "随着口碑发酵，影院已宣布适当增加排片场次。影评人提醒，这部作品更适合静下心来欣赏，建议观众避开最热闹的周末夜场，以获得更完整的观影体验。",
    ],
  },
  {
    id: 2,
    slug: "yule-weiluhuaye-shouguan",
    title: "真人秀《围炉夜话》收官：慢综艺为何频频破圈",
    summary:
      "一档没有竞技、没有淘汰的慢综艺，收官之夜的网络讨论量却突破新高。从'下饭'到'治愈'，慢综艺正在重新定义观众与节目的关系。",
    category: "yule",
    categoryName: "娱乐",
    tags: ["综艺", "观察", "热议"],
    author: "本网娱乐组",
    timeLabel: "10:40",
    dateLabel: "2026-09-07",
    views: 152000,
    image:
      "https://readdy.ai/api/search-image?query=cozy%20warm%20flat%20illustration%20of%20friends%20gathered%20around%20a%20fireside%20table%20with%20steaming%20tea%20and%20warm%20lamplight%2C%20editorial%20minimalist%20style%2C%20golden%20amber%20and%20cream%20tones%2C%20soft%20shadows%2C%20relaxed%20evening%20mood&width=800&height=600&seq=slow-tv-02&orientation=landscape",
    content: [
      "本季《围炉夜话》在收官夜迎来话题高峰。节目没有复杂赛制，几位嘉宾围坐夜谈，聊工作、聊家庭、聊各自的中年困惑，却意外击中大量观众内心。相关讨论连续数日登上热搜。",
      "制作人坦言，过去做综艺总担心节奏慢、怕观众流失，这档节目恰恰反其道而行。\"大家现在都很累，与其制造焦虑，不如提供一点喘息的空间。\"",
      "行业观察认为，慢综艺的破圈并非偶然。当快节奏内容高度同质化，真诚、克制、能提供情绪价值的内容反而更稀缺。观众要的不是节目本身的刺激，而是从中看见自己。",
      "据平台数据，本季节目平均观看完成率明显高于同期竞技类节目，女性观众与一线城市观众占比突出。已有平台宣布启动下一季筹备。",
    ],
  },
  {
    id: 3,
    slug: "yule-shuangchengji-dajieju",
    title: "热播剧《双城记》迎大结局，开放式收尾引发两派争论",
    summary:
      "追了两个月的热播剧迎来大结局，主角命运却留下开放式悬念。一时间'圆满派'与'意难平派'吵翻了天，相关话题阅读量破亿。",
    category: "yule",
    categoryName: "娱乐",
    tags: ["电视剧", "结局", "讨论"],
    author: "本网娱乐组",
    timeLabel: "21:05",
    dateLabel: "2026-09-06",
    views: 198000,
    image:
      "https://readdy.ai/api/search-image?query=two%20silhouettes%20standing%20on%20opposite%20city%20bridges%20at%20twilight%2C%20warm%20minimalist%20editorial%20illustration%2C%20split%20duotone%20of%20coral%20red%20and%20deep%20blue%20night%2C%20cinematic%20atmosphere%2C%20clean%20flat%20composition&width=800&height=600&seq=drama-final-03&orientation=landscape",
    content: [
      "备受关注的都市情感剧《双城记》于昨晚正式收官。大结局中，跨越两地多年的主角在机场偶遇，画面定格在两人相视而笑的一瞬，故事就此戛然而止，为观众留下巨大的想象空间。",
      "结局播出后，社交平台瞬间分裂为两大阵营。一派认为开放式结尾留白高级、余味悠长；另一派则直呼'意难平'，希望看到更明确的圆满。相关词条阅读量在数小时内突破一亿。",
      "编剧在采访中回应，比起给出答案，更希望让每个观众带着自己的经历去补全结局。\"生活本来就有很多可能，他们未必非要在同一座城市才算幸福。\"",
      "尽管争议不断，剧集整体口碑依然稳固，豆瓣评分维持在 8.3 分。片方表示番外篇已在筹备中，将聚焦主角重逢后的生活细节。",
    ],
  },
  {
    id: 4,
    slug: "shehui-tongqinbashi",
    title: "本市试点\"通勤巴士\"定制线路，早高峰出行迎来新选择",
    summary:
      "针对跨区上班族通勤时间过长的痛点，本市多条定制通勤巴士线路开启试点。手机预约、一人一座、准时发车，让'掐点上班'成为可能。",
    category: "shehui",
    categoryName: "社会",
    tags: ["民生", "交通"],
    author: "本网社会组",
    timeLabel: "07:30",
    dateLabel: "2026-09-07",
    isTop: true,
    views: 124000,
    image:
      "https://readdy.ai/api/search-image?query=modern%20commuter%20bus%20driving%20through%20a%20bright%20sunrise%20city%20street%2C%20warm%20minimalist%20editorial%20illustration%2C%20coral%20and%20cream%20tones%2C%20soft%20morning%20light%2C%20clean%20flat%20urban%20scene%20with%20trees&width=800&height=600&seq=commute-bus-04&orientation=landscape",
    content: [
      "清晨六点半，位于郊区的通勤巴士首发站已陆续有乘客候车。与普通公交不同，这里的座位需要提前在手机端预约，一人一座、准点发车，全程不停靠冗余站点。",
      "作为试点线路之一，这条连接大型居住区与高新园区的通勤巴士，把原本单程近一个半小时的换乘时间压缩到五十分钟左右。不少首批体验的市民感叹，终于可以\"坐下来通勤\"了。",
      "运营方介绍，线路设计综合了前期大数据调研，覆盖了近两万人的高频通勤需求。票价略高于普通公交，但对比网约车仍具明显价格优势，且可享受定期券优惠。",
      "交通部门表示，试点期将持续三个月，后续将根据上座率与乘客反馈动态优化站点和班次，条件成熟后再向更多跨区线路推广。",
    ],
  },
  {
    id: 5,
    slug: "shehui-shequ-shitang",
    title: "社区食堂成\"新宠\"：一顿热乎饭背后的烟火气",
    summary:
      "从老年人专属到全龄友好，社区食堂正在悄悄'出圈'。十余元的暖心套餐、明厨亮灶的放心出品，让上班族也愿意中午来蹭一顿。",
    category: "shehui",
    categoryName: "社会",
    tags: ["社区", "民生", "烟火气"],
    author: "本网社会组",
    timeLabel: "12:20",
    dateLabel: "2026-09-07",
    views: 96000,
    image:
      "https://readdy.ai/api/search-image?query=warm%20cozy%20illustration%20of%20a%20bright%20neighborhood%20community%20canteen%20serving%20steaming%20homestyle%20meals%2C%20people%20dining%20together%2C%20editorial%20minimalist%20flat%20style%2C%20cream%20and%20coral%20palette%2C%20soft%20warm%20light&width=800&height=600&seq=community-canteen-05&orientation=landscape",
    content: [
      "临近中午，位于老城区的这家社区食堂开始热闹起来。干净明亮的档口里，十来道家常菜冒着热气，荤素搭配的自选套餐定价亲民，吸引的不只是老人，还有不少附近的年轻上班族。",
      "社区负责人介绍，食堂最初主要面向辖区老年居民，推出针对老年群体的优惠补贴。运营一段时间后发现，'明厨亮灶''食材可追溯'这些卖点同样打动年轻食客，索性面向全龄开放。",
      "对不少独居和双职工家庭而言，一顿干净卫生的热乎饭解决了实实在在的生活难题。'自己做饭费时间，点外卖又不放心，这里便宜还放心。'一位常客说出了许多人的心声。",
      "业内认为，社区食堂承载的不只是三餐，更是一份触手可及的归属感。随着更多社会资本与专业运营团队进入，社区助餐正在从'兜底'走向'品质'。",
    ],
  },
  {
    id: 6,
    slug: "shehui-waimai-fangshu",
    title: "高温下的\"骑士\"：配送平台上线防暑关怀新举措",
    summary:
      "连日高温让外卖配送小哥的辛劳备受关注。多家平台上线防暑关怀举措：高温补贴、避暑休息点、强制防暑提醒，守护烈日下的每一单。",
    category: "shehui",
    categoryName: "社会",
    tags: ["外卖", "劳动者", "关怀"],
    author: "本网社会组",
    timeLabel: "16:45",
    dateLabel: "2026-09-06",
    views: 88000,
    image:
      "https://readdy.ai/api/search-image?query=illustration%20of%20a%20delivery%20rider%20resting%20in%20the%20shade%20with%20a%20cooling%20drink%20on%20a%20sunny%20day%2C%20warm%20flat%20editorial%20style%2C%20golden%20sun%20rays%2C%20coral%20and%20cream%20tones%2C%20care%20and%20comfort%20mood&width=800&height=600&seq=delivery-heat-06&orientation=landscape",
    content: [
      "连日高温炙烤着城市的每一个角落，也考验着穿梭在街头巷尾的配送骑手。为保障劳动者安全与健康，多家外卖平台近日集中上线了防暑关怀举措。",
      "最直观的变化来自补贴与结算。部分平台在高温时段自动上调配送单价，并依据实时气象数据动态发放高温补贴，让骑手在烈日下跑单能获得更合理的回报。",
      "线下的'避暑驿站'也在扩容。联合商圈与门店设置的休息点提供饮用水、空调与防暑药品，骑手可随时进店纳凉。系统同时会在极端高温时段对连续作业的骑手进行强制提醒，避免中暑风险。",
      "有骑手坦言，政策之外更在意的是被看见。多位受访者表示，盛夏最难熬的不是体力透支，而是无人接单的压力与偶尔被催促的焦虑。平台方称，将持续优化调度算法，让关怀真正落在每一单上。",
    ],
  },
  {
    id: 7,
    slug: "keji-ai-jinrichang",
    title: "AI 助手正走进寻常生活：从写周报到定行程",
    summary:
      "写周报、订行程、理思路……曾经'高端'的 AI 助手，正以更平民的姿态进入普通人的日常工作。好用与否，亲测见真章。",
    category: "keji",
    categoryName: "科技",
    tags: ["AI", "效率", "应用"],
    author: "本网科技组",
    timeLabel: "09:15",
    dateLabel: "2026-09-07",
    isTop: true,
    views: 210000,
    image:
      "https://readdy.ai/api/search-image?query=friendly%20flat%20illustration%20of%20a%20person%20using%20a%20laptop%20with%20glowing%20AI%20assistant%20sparkles%20and%20floating%20task%20cards%2C%20warm%20modern%20editorial%20style%2C%20coral%20accent%20and%20cream%20background%2C%20clean%20minimalist&width=800&height=600&seq=ai-life-07&orientation=landscape",
    content: [
      "'周一还没想好周报写什么，让 AI 帮忙先搭个框架，再往里填具体内容，效率高多了。'一位互联网从业者这样分享自己的新习惯。曾经被视为高端工具的 AI 助手，正在渗透普通人的日常。",
      "从会议纪要到邮件润色，从行程规划到资料梳理，大模型工具的应用场景正变得愈发贴近生活。对许多非技术背景的用户来说，它更像一个随时在线、且足够耐心的'助理'。",
      "不过，好用并不等于无脑信任。记者实测发现，AI 在信息准确性和时效性上仍有短板，容易一本正经地'编造'细节。专家提醒，重要事实务必人工核对，AI 适合做'草稿'而非'结论'。",
      "业内人士判断，随着工具越来越普及，真正拉开差距的将不再是'会不会用 AI'，而是'会不会提出好问题'。会提问的人，正把 AI 用成效率放大器。",
    ],
  },
  {
    id: 8,
    slug: "keji-zhedieping",
    title: "轻薄化之争：新一代折叠屏手机集中发布",
    summary:
      "折叠屏手机迎来集中发布潮，'更轻、更薄、更耐用'成为主旋律。价格下探与形态成熟，是否意味着折叠屏时代真正到来？",
    category: "keji",
    categoryName: "科技",
    tags: ["手机", "数码", "折叠屏"],
    author: "本网科技组",
    timeLabel: "14:30",
    dateLabel: "2026-09-06",
    views: 167000,
    image:
      "https://readdy.ai/api/search-image?query=sleek%20flat%20illustration%20of%20a%20modern%20foldable%20smartphone%20unfolding%20on%20a%20clean%20desk%2C%20warm%20minimalist%20tech%20editorial%20style%2C%20cream%20background%20with%20soft%20coral%20and%20golden%20accents%2C%20premium%20clean%20product%20rendering%20feel&width=800&height=600&seq=foldable-phone-08&orientation=landscape",
    content: [
      "进入九月，手机市场的关键词被'折叠'牢牢占据。多家厂商不约而同地发布新一代折叠屏旗舰，主打卖点高度一致：更轻的机身、更薄的厚度，以及更耐用的铰链与屏幕。",
      "曾经的'板砖'印象正在被改写。记者上手体验发现，新一代产品在展开状态下已能做到与常规直板旗舰相当的重量，合上时则更接近一部精致的直板手机，随身携带的负担大幅降低。",
      "价格同样在松动。随着供应链成熟与成本摊薄，主流折叠屏价格已从此前的万元档逐渐下探，部分产品进入五六千元区间，让更多观望中的消费者愿意尝鲜。",
      "分析人士指出，折叠屏能否真正成为主流，取决于三大痛点：可靠性与维修成本、软件适配深度，以及大屏形态是否真正带来不可替代的效率。新一轮产品在这些维度均有明显进步，但距离全面普及仍需观察。",
    ],
  },
  {
    id: 9,
    slug: "keji-quanwu-iot",
    title: "全屋智能再提速：跨品牌设备开始\"说同一种话\"",
    summary:
      "不同品牌的家电曾像'语言不通'的邻居。如今统一互联标准加速落地，空调、灯光、窗帘跨品牌联动成为可能，智能家居体验迎来质变。",
    category: "keji",
    categoryName: "科技",
    tags: ["智能家居", "互联", "生态"],
    author: "本网科技组",
    timeLabel: "18:20",
    dateLabel: "2026-09-05",
    views: 74000,
    image:
      "https://readdy.ai/api/search-image?query=warm%20flat%20illustration%20of%20a%20cozy%20modern%20living%20room%20with%20smart%20connected%20appliances%2C%20lamp%20curtains%20and%20air%20conditioner%20linked%20by%20subtle%20glowing%20lines%2C%20editorial%20minimalist%20style%2C%20cream%20and%20golden%20tones%2C%20cozy%20home%20mood&width=800&height=600&seq=smart-home-09&orientation=landscape",
    content: [
      "过去几年，智能家居常被吐槽为'买一堆 App 各管各的'。不同品牌设备如同语言不通的邻居，难以顺畅协作。而随着统一互联标准加速落地，这种割裂正在被打破。",
      "如今，支持新标准的空调、灯光、窗帘、门锁等设备，即便来自不同品牌，也能通过一个入口统一管理和联动。一句'回家模式'，即可让灯光渐亮、空调开启、窗帘拉合。",
      "对用户而言，最大的好处是选择的自由。不必为了联动而被迫'全家桶'式购买单一品牌，真正做到按需组合。厂商也意识到，封闭生态正在让位于开放协作。",
      "不过标准落地仍面临新旧设备兼容的现实难题。已购买的老设备可能需要额外网关才能接入。业内预计，随着存量设备自然换代，跨品牌互联的体验将越来越顺畅。",
    ],
  },
  {
    id: 10,
    slug: "caijing-guoxiang-lishun",
    title: "国庆出游预订升温，\"反向旅游\"成年轻人新选项",
    summary:
      "距离黄金周还有近一个月，出行预订已明显升温。除了热门目的地，越来越多年轻人把目光投向'反向旅游'的小众城市，追求松弛感。",
    category: "caijing",
    categoryName: "财经",
    tags: ["消费", "旅游", "反向旅游"],
    author: "本网财经组",
    timeLabel: "11:10",
    dateLabel: "2026-09-07",
    isTop: true,
    views: 176000,
    image:
      "https://readdy.ai/api/search-image?query=warm%20flat%20illustration%20of%20a%20backpack%20traveler%20with%20suitcase%20and%20map%20heading%20to%20a%20quaint%20small%20town%2C%20editorial%20minimalist%20style%2C%20cream%20and%20coral%20palette%2C%20relaxed%20journey%20mood%2C%20golden%20autumn%20light&width=800&height=600&seq=trip-booking-10&orientation=landscape",
    content: [
      "虽距离黄金周还有近一个月，各家平台的国庆出游预订已悄然升温。机票、酒店预订量环比明显增长，热门目的地的高铁票更是早早进入'候补'状态。",
      "与往年不同的是，今年预订主力中出现了更多'反向旅游'的声音。面对热门景区的人山人海与高企的住宿价格，一批年轻人选择把小众县域城市、非传统旅游目的地纳入清单，追求松弛而非打卡。",
      "某旅行平台数据显示，部分冷门目的地的搜索量同比翻倍，周边民宿、当地美食与特色体验成为决策重点。'花更少的钱，体验更local的生活'，是许多选择反向出行的消费者的共同心态。",
      "业内人士提醒，反向旅游同样需要提前规划。小众目的地接待能力有限，交通与住宿资源紧张，建议预订前确认好班次与退改政策，让假期真正松弛下来。",
    ],
  },
  {
    id: 11,
    slug: "caijing-guochao-hufu",
    title: "国货美妆凭\"平替+成分\"双引擎，暑期消费持续走俏",
    summary:
      "从成分透明到情绪价值，一批国货美妆品牌正靠'平替'与'功效'两条腿走路。暑期大促数据亮眼，国货护肤消费迎来新一波热潮。",
    category: "caijing",
    categoryName: "财经",
    tags: ["国货", "美妆", "消费"],
    author: "本网财经组",
    timeLabel: "15:55",
    dateLabel: "2026-09-06",
    views: 103000,
    image:
      "https://readdy.ai/api/search-image?query=elegant%20flat%20illustration%20of%20a%20minimalist%20skincare%20product%20collection%20with%20cream%20jars%20and%20bottles%2C%20warm%20editorial%20beauty%20style%2C%20cream%20and%20soft%20coral%20tone%2C%20clean%20premium%20composition&width=800&height=600&seq=skincare-cny-11&orientation=landscape",
    content: [
      "暑期消费旺季里，国货美妆的表现颇为亮眼。多家平台大促数据显示，主打'大牌平替'与'成分功效'的国货护肤品牌销售持续走俏，成交额同比实现两位数增长。",
      "对许多年轻消费者而言，国货的吸引力来自'看得懂的成分'。把烟酰胺、玻色因等核心成分的功效和浓度写清楚，配合更亲民的价格，正在重构其'贵就是好'的护肤决策逻辑。",
      "除了功效，情绪价值同样成为加分项。国潮包装、本土原料故事与品牌人格化运营，让消费者在买产品之余获得认同感。多位受访者表示，好用且'懂我'，是回购的核心原因。",
      "分析人士提醒，成分营销热潮下，消费者应理性看待'浓度'与'功效'的关系，并非越高越好，还需结合肤质。品牌方也需在产品力上持续投入，避免概念先行、口碑透支。",
    ],
  },
  {
    id: 12,
    slug: "tiyu-pingpang-liansai",
    title: "乒超联赛激战正酣，年轻小将扛起大梁",
    summary:
      "本赛季乒超联赛赛程过半，多支队伍展现新气象。一批二十岁上下的年轻小将在关键场次挺身而出，成为联赛最亮眼的风景。",
    category: "tiyu",
    categoryName: "体育",
    tags: ["乒乓球", "联赛", "新人"],
    author: "本网体育组",
    timeLabel: "20:10",
    dateLabel: "2026-09-07",
    views: 131000,
    image:
      "https://readdy.ai/api/search-image?query=dynamic%20flat%20illustration%20of%20a%20table%20tennis%20player%20in%20action%20hitting%20a%20smash%20with%20motion%20lines%2C%20energetic%20warm%20editorial%20sport%20style%2C%20coral%20red%20and%20cream%20tones%2C%20clean%20minimalist%20stadium%20background&width=800&height=600&seq=pingpong-12&orientation=landscape",
    content: [
      "本赛季乒超联赛赛程过半，各队积分争夺进入白热化。与过往相比，今年最引人注目的变化，是一批二十岁上下的年轻选手开始在关键场次挑起大梁。",
      "在昨晚的一场强强对话中，某位不满二十岁的小将面对经验丰富的老将毫不怯场，多次在关键分上果断出手，最终帮助球队逆转取胜。赛后他坦言，站上这样的舞台，'紧张但更兴奋'。",
      "俱乐部教练表示，随着联赛职业化程度提高，年轻队员获得了更多高质量对抗机会，以赛代练、以赛促成长的效果愈发明显。'年轻人有冲劲，缺的是大赛经验，联赛正好补上这一课。'",
      "体育评论员认为，乒超赛场上新老交错的竞争格局，正是项目可持续发展的健康信号。当后备力量能够源源不断地涌现，国球的领先地位才有更坚实的底气。",
    ],
  },
  {
    id: 13,
    slug: "tiyu-malasong-baoming",
    title: "秋季马拉松热潮回归，\"跑圈\"报名拼手速",
    summary:
      "气温转凉，全国马拉松赛事进入密集开跑季。热门赛事名额'一票难求'，报名靠抢、中签靠运气，大众跑步热情持续高涨。",
    category: "tiyu",
    categoryName: "体育",
    tags: ["马拉松", "全民健身", "报名"],
    author: "本网体育组",
    timeLabel: "08:50",
    dateLabel: "2026-09-05",
    views: 92000,
    image:
      "https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20crowd%20of%20runners%20crossing%20a%20city%20start%20line%20at%20sunrise%2C%20warm%20energetic%20editorial%20sport%20style%2C%20golden%20and%20coral%20tones%2C%20motion%20and%20enthusiasm%2C%20clean%20minimalist&width=800&height=600&seq=marathon-13&orientation=landscape",
    content: [
      "随着气温转凉，全国马拉松赛事正式进入一年中最密集的开跑季。多地马拉松的报名通道一开启便涌入大量跑者，热门赛事名额常常在几分钟内被抢空。",
      "'报名全靠手速，中签全靠运气。'一位连续报名三年、终于拿到心仪城市赛事名额的跑者这样形容。为让更多大众跑者参与，不少赛事增设了团体、慈善与直通名额，报名方式更加多元。",
      "马拉松热度的背后，是全民健身意识的持续升温。从晨跑人群到夜跑族，从公园跑团到城市赛道，跑步正成为越来越多人的生活习惯。跑鞋、运动手表等相关消费也随之走俏。",
      "运动医学专家提醒，秋季赛事密集，跑者切忌盲目上量。备战应循序渐进、做好拉伸与补给，并根据自身状态合理选择全程或半程组别，享受过程远比刷个人最佳更重要。",
    ],
  },
];